// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/Content/IdeasLab/ImagesUploadSection.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FileUpload } from 'primereact/fileupload';
import { OrderList } from 'primereact/orderlist';

const ImagesUploadSection = ({
  mode,
  isUploading,
  isLoadingImages,
  existingImages,
  tempFiles,
  handleFileSelect,
  handleDeleteImage,
  handleOrderChange,
  setExistingImages,
  setFormData,
}) => {
  const itemTemplate = (image) => {
    return (
      <div className="ideaslab-image-item">
        <img
          className="ideaslab-image-preview"
          src={image.ImgHome_Img}
          alt={`Image ${image.ImgHome_ID}`}
          onError={(e) => {
            console.error('Failed to load image:', image.ImgHome_Img);
            e.target.style.display = 'none';
          }}
        />
        <div className="ideaslab-image-info">
          <span className="ideaslab-image-id">ID: {image.ImgHome_ID}</span>
          <span className="ideaslab-image-sort">Sort: {image.ImgHome_Sort}</span>
        </div>
        {mode === 'edit' && (
          <button
            type="button"
            className="ideaslab-delete-btn"
            onClick={() => handleDeleteImage(image.ImgHome_ID)}
            disabled={isUploading || isLoadingImages}
          >
            <FontAwesomeIcon icon={faTrash} /> Delete
          </button>
        )}
      </div>
    );
  };

  return (
    <div className="mb-3">
      <label className="form-label">Images:</label>
      {isLoadingImages ? (
        <p>Loading images...</p>
      ) : (
        <>
          <FileUpload
            name="images"
            accept="image/*"
            maxFileSize={10000000}
            customUpload={true}
            onSelect={handleFileSelect}
            auto="false"
            showUploadButton="false"
            chooseLabel="Select Images"
            cancelLabel="Cancel"
            disabled={isUploading || isLoadingImages}
            multiple
            emptyTemplate={<p className="m-0">Drag and drop images here or click to select.</p>}
          />
          {existingImages.length > 0 && (
            <div className="mt-2">
              <OrderList
                dataKey="ImgHome_ID"
                value={existingImages}
                onChange={handleOrderChange}
                itemTemplate={itemTemplate}
                header="Existing Images"
                dragdrop
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ImagesUploadSection;